var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFairy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21029 12.6872L5.77669 11.9431L7.99333 15.9961C7.99623 16.0013 8.00377 16.0013 8.00664 15.9961L10.2233 11.9431L12.7897 12.6872C12.7955 12.6889 12.8008 12.6835 12.7991 12.6778L12.0548 10.1622L15.996 8.00664C16.0013 8.00377 16.0013 7.99623 15.9961 7.99336L12.0223 5.82004L12.7991 3.19464C12.8008 3.18889 12.7955 3.18354 12.7897 3.1852L10.1631 3.94682L8.00664 0.00394351C8.00377 -0.00131441 7.99623 -0.00131455 7.99336 0.00394338L5.83691 3.94682L3.21029 3.1852C3.20454 3.18354 3.1992 3.18889 3.20092 3.19464L3.97766 5.82004L0.00394351 7.99336C-0.00131441 7.99623 -0.00131455 8.00377 0.00394338 8.00664L3.94516 10.1622L3.20092 12.6778C3.1992 12.6835 3.20454 12.6889 3.21029 12.6872ZM5.2018 8.02764L7.01995 9.02202L8.01433 10.8401C8.0172 10.8454 8.02477 10.8454 8.02764 10.8401L9.02202 9.02202L10.8401 8.02764C10.8454 8.02477 10.8454 8.0172 10.8401 8.01433L9.02202 7.01995L8.02764 5.20183C8.02477 5.19655 8.0172 5.19655 8.01433 5.20183L7.01995 7.01995L5.2018 8.01433C5.19655 8.0172 5.19655 8.02477 5.2018 8.02764Z",
    fill: "#E296E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairy);
export default __webpack_public_path__ + "static/media/fairy.5bf6927041c0da5b4806039757c89edc.svg";
export { ForwardRef as ReactComponent };